import { useMutation } from "@tanstack/react-query";
import { Post } from "../../../utils/apiService";
import {
  ExecuteViewQueryBody,
  GetAllPersonsByIPFRBody,
  GetAPILogFileBody,
  GetFRTokenByIPActionBody,
  PingDeviceByIPBody,
} from "../interface";

const getAPILogFileAction = async (body: GetAPILogFileBody) => {
  return Post({
    url: "/api/TekConfig/GetAPILogFile",
    body,
  });
};

export const useGetAPILogFile = () => {
  return useMutation({
    mutationFn: async (body: GetAPILogFileBody) => getAPILogFileAction(body),
  });
};

const pingDeviceByIPAction = async (body: PingDeviceByIPBody) => {
  return Post({
    url: "/api/FR/PingDeviceByIP",
    body,
  });
};

export const usePingDeviceByIP = () => {
  return useMutation({
    mutationFn: async (body: PingDeviceByIPBody) => pingDeviceByIPAction(body),
  });
};

const getFRTokenByIPAction = async (body: GetFRTokenByIPActionBody) => {
  return Post({
    url: "/api/FR/GetFRTokenByIP",
    body,
  });
};

export const useGetFRTokenByIP = () => {
  return useMutation({
    mutationFn: async (body: GetFRTokenByIPActionBody) =>
      getFRTokenByIPAction(body),
  });
};

const getAllPersonsByIPFRAction = async (body: GetAllPersonsByIPFRBody) => {
  return Post({
    url: "/api/FR/GetAllPersonsByIP_FR",
    body,
  });
};

export const useGetAllPersonsByIPFR = () => {
  return useMutation({
    mutationFn: async (body: GetAllPersonsByIPFRBody) =>
      getAllPersonsByIPFRAction(body),
  });
};

const executeViewQueryAction = async (body: ExecuteViewQueryBody) => {
  return Post({
    url: "/api/TekConfig/ExecuteViewQuery",
    body,
  });
};

export const useExecuteViewQuery = () => {
  return useMutation({
    mutationFn: async (body: ExecuteViewQueryBody) =>
      executeViewQueryAction(body),
  });
};
